'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelTransaction = exports.failTransaction = exports.endTransaction = exports.beginTransaction = exports.onBeforeErrorSend = exports.notify = exports.setAllowedDomains = exports.setTags = exports.setCustomData = exports.setUser = exports.enableOffline = exports.setVersion = exports.config = undefined;
var _index = require('./index');
function getConfigKey(keys) {
  return process.env.ATATUS_CONFIG_KEY || keys[_index.endpoints.rootDomain];
}
function atatusChecker(f) {
  if (global && global.window && global.window.atatus) {
    return f;
  }
  return function () {};
}

/**
 * Initializes the use of atatus library on the website. Same as atatus.config
 * function (details: https://www.atatus.com/docs/advanced-usage), but with one additonal feature,
 * the API key can be provided with either the environment variable `ATATUS_CONFIG_KEY`,
 * or with an object that should contain keys for different possible values of root domain.
 * The environment variable will always be used first if provided.
 *
 * Example keys objects:
 * {
 *   'import.io': 'PRODUCTION_ATATUS_KEY',
 *   'staging-owl.com': 'STAGING_ATATUS_KEY'
 * }
 * @param {Object}  keys      Object cotaining atatus API keys for different environments.
 *                            This parameter will be ignored if `ATATUS_CONFIG_KEY` environment
 *                            variable is provided.
 * @param {Object}  settings  Settings object, allowing to provide additonal options.
 *                            Possible values defined here: https://www.atatus.com/docs/advanced-usage
 */
var config = exports.config = atatusChecker(function (keys) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  global.window.atatus.config(getConfigKey(keys), settings).install();
});

/**
 * Sets the application version that will be sent to atatus.
 * One modification, over the normal atatus method, is that version cvan also be set
 * with environment variable `ATATUS_VERSION_NUMBER`. If this environment variable is set,
 * it will be used, regardless of the version parameter provided.
 * If no paramters is provided, the version will default to '0.0.0'.
 * Details here: https://www.atatus.com/docs/advanced-usage#application-version
 * @param  {String} version Application version to be sent to atatus. This paramter is not used
 *                          if `ATATUS_VERSION_NUMBER` environment variable is provided.
 */
var setVersion = exports.setVersion = atatusChecker(function () {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0.0.0';
  global.window.atatus.setVersion(process.env.ATATUS_VERSION_NUMBER || version);
});

/**
 * Allows specifying if Atatus should work offline. Usage is the same
 * as: https://www.atatus.com/docs/advanced-usage#offline-saving
 * @param  {Boolean} shouldEnable Flag setting if offline mode should be turned on.
 */
var enableOffline = exports.enableOffline = atatusChecker(function (shouldEnable) {
  global.window.atatus.enableOffline(shouldEnable);
});

/**
 * Allows specifying userId to Atatus. Usage is the same
 * as: https://www.atatus.com/docs/advanced-usage#user-tracking
 * @param  {String} userId userId to be provided to Atatus.
 */
var setUser = exports.setUser = atatusChecker(function (userId) {
  global.window.atatus.setUser(userId);
});

/**
 * Allows specifying additional custom data. Usage is the same as:
 * https://www.atatus.com/docs/advanced-usage#custom-data
 * @param  {Object} userData Data to be sent to Atatus.
 */
var setCustomData = exports.setCustomData = atatusChecker(function (userData) {
  global.window.atatus.setCustomData(userData);
});

/**
 * Allows specifying additional session tags. Usage is the same as:
 * https://www.atatus.com/docs/advanced-usage#tags
 * @param  {Array} tags Array of string tags to be sent to Atatus.
 */
var setTags = exports.setTags = atatusChecker(function (tags) {
  global.window.atatus.setTags(tags);
});

/**
 * Allows specifying allowed domains. Usage is the same as:
 * https://www.atatus.com/docs/advanced-usage#allowed-domains
 * @param  {Array} tags Array of domain to be allowed in Atatus.
 */
var setAllowedDomains = exports.setAllowedDomains = atatusChecker(function (domains) {
  global.window.atatus.setAllowedDomains(domains);
});

/**
 * Function that allows to specify additional behaviour before sendinf an error to Atatus.
 * Usage is the same as: https://www.atatus.com/docs/advanced-usage#onbefore-errorsend
 */
var notify = exports.notify = atatusChecker(function () {
  var _global$window$atatus;
  (_global$window$atatus = global.window.atatus).notify.apply(_global$window$atatus, arguments);
});

/**
 * Function that allows to send custom errors to Atatus. Usage is the same as:
 * https://www.atatus.com/docs/advanced-usage#custom-errors
 */
var onBeforeErrorSend = exports.onBeforeErrorSend = atatusChecker(function () {
  var _global$window$atatus2;
  (_global$window$atatus2 = global.window.atatus).onBeforeErrorSend.apply(_global$window$atatus2, arguments);
});

/**
 * Same as described here: https://www.atatus.com/docs/performances/transactions
 */
var beginTransaction = exports.beginTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.beginTransaction(transactionKeyName);
});

/**
 * Same as described here: https://www.atatus.com/docs/performances/transactions
 */
var endTransaction = exports.endTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.endTransaction(transactionKeyName);
});

/**
 * Same as described here: https://www.atatus.com/docs/performances/transactions
 */
var failTransaction = exports.failTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.failTransaction(transactionKeyName);
});

/**
 * Same as described here: https://www.atatus.com/docs/performances/transactions
 */
var cancelTransaction = exports.cancelTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.cancelTransaction(transactionKeyName);
});